var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28.24,
    viewBox: "0 0 28 28.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bulk_Category",
    "data-name": "Iconly/Bulk/Category",
    transform: "translate(-3 -2.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Category",
    transform: "translate(2.759 2.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M3.5,0H8.174a3.517,3.517,0,0,1,3.5,3.532V8.243a3.517,3.517,0,0,1-3.5,3.532H3.5A3.517,3.517,0,0,1,0,8.243V3.532A3.517,3.517,0,0,1,3.5,0",
    transform: "translate(15.917)",
    fill: "#00ff5f",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M19.705,28a3.569,3.569,0,0,1-3.553-3.583v-4.78a3.569,3.569,0,0,1,3.553-3.585h4.741A3.569,3.569,0,0,1,28,19.636v4.78A3.569,3.569,0,0,1,24.447,28ZM3.554,28A3.57,3.57,0,0,1,0,24.417v-4.78a3.57,3.57,0,0,1,3.554-3.585h4.74a3.569,3.569,0,0,1,3.553,3.585v4.78A3.569,3.569,0,0,1,8.295,28Zm0-16.051A3.569,3.569,0,0,1,0,8.364V3.583A3.569,3.569,0,0,1,3.554,0h4.74a3.568,3.568,0,0,1,3.553,3.583v4.78a3.568,3.568,0,0,1-3.553,3.585Z",
    transform: "translate(0.241 0.24)",
    fill: "#00ff5f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.2ff5c0651abd88eb8e41e6ab86f0fa3b.svg";
export { ForwardRef as ReactComponent };